module.exports = __webpack_public_path__ + "static/media/6.14_preview.3f9949fb.png";